<div class="crud-container">
    <h2 class="page-title">{{ crudConfig.tableName | titlecase }}</h2>
  
    <div class="table-wrapper" *ngIf="!isLoading()">
      <table class="table table-hover">
        <thead>
          <tr>
            <th *ngFor="let column of columns">{{ column.columnName | titlecase }}</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of displayedData">
            <td *ngFor="let column of columns">
              <ng-container *ngIf="editingRow === row; else displayCell">
                <mat-form-field *ngIf="column.dataType === 'varchar'" class="form-field">
                  <mat-label>{{ column.columnName | titlecase }}</mat-label>
                  <input matInput [(ngModel)]="row[column.columnName]" />
                </mat-form-field>
  
                <mat-slide-toggle *ngIf="column.dataType === 'boolean'" [(ngModel)]="row[column.columnName]">
                </mat-slide-toggle>
              </ng-container>
              <ng-template #displayCell>
                {{ row[column.columnName] }}
              </ng-template>
            </td>
            <td>
              <div class="d-flex flex-row">
                <button *ngIf="editingRow === row" (click)="cancelEdit()" class="btn btn-secondary btn-sm">
                  <i class="fas fa-times"></i> Cancel
                </button>
                <button *ngIf="editingRow !== row" (click)="editRow(row)" class="btn btn-primary btn-sm">
                  <i class="fas fa-edit"></i>
                </button>
                <button (click)="deleteRow(row)" class="btn btn-danger btn-sm">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
              
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <mat-spinner *ngIf="isLoading()"></mat-spinner>
    <!-- Pagination Controls -->
    <div class="pagination-controls">
      <button class="btn btn-secondary btn-sm" (click)="previousPage()" [disabled]="currentPage === 1">
        <i class="fas fa-chevron-left"></i> Prev
      </button>
      <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
      <button class="btn btn-secondary btn-sm" (click)="nextPage()" [disabled]="currentPage === totalPages">
        Next <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>

  <button class="btn btn-primary add-btn" (click)="addRow()" *ngIf="isCurrentStatus('read')">
    <i class="fas fa-plus"></i> Add New Row
  </button>

  <app-dynamic-crud-form [config]="crudConfig" (dataOut)="processOp($event)"></app-dynamic-crud-form> 

<!--   <app-dynamic-crud-form  [props]="columns2"></app-dynamic-crud-form>  -->


  